import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { optionText, selectedOptionText, optionButtonVariants } from "./styles_vanilla.css";

export type OptionButtonProps = {
  name: string;
  isSelected: boolean;
  onClick: () => void;
  isLoading?: boolean;
};

export const OptionButton = ({
  name,
  isSelected,
  onClick,
  isLoading = false,
}: OptionButtonProps) => {
  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      if (!isLoading) {
        onClick();
      }
    }
  };

  const handleClick = () => {
    if (!isLoading) {
      onClick();
    }
  };

  let buttonVariant: keyof typeof optionButtonVariants;

  switch (true) {
    case isSelected && isLoading: {
      buttonVariant = "selectedLoading";
      break;
    }
    case isSelected: {
      buttonVariant = "selected";
      break;
    }
    case isLoading: {
      buttonVariant = "loading";
      break;
    }
    default: {
      buttonVariant = "default";
    }
  }

  const buttonClass = optionButtonVariants[buttonVariant];
  const textClass = isSelected ? selectedOptionText : optionText;
  const textContent = isLoading ? "Loading..." : name;

  return (
    <Flex
      className={buttonClass}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={handleKeyDown}
      alignItems="center"
      justifyContent="center"
    >
      <Text variant="regular-md" className={textClass}>
        {textContent}
      </Text>
    </Flex>
  );
};
